module.exports = __webpack_public_path__ + "static/media/Logo-Fice.ad919254.png";